const FONT_FAMILY_UI = '"Inter", "Adjusted Arial", Tahoma, Geneva, sans-serif';
export {
  FONT_FAMILY_UI
};
